module.exports = __webpack_public_path__ + "img/home4.7aecbb9c.svg";